import { computed } from 'vue';
import { useStore } from 'vuex';

export function useAuth() {
  const store = useStore();
  const auth = computed(() => store.state.auth);
  // expose managed state as return value
  return { auth };
}
